export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export const OPEN_FORM = 'OPEN_FORM';

export const SET_GLOBAL_ACTIVITIES = 'SET_GLOBAL_ACTIVITIES';

export const SET_My_ACTIVITIES = 'SET_My_ACTIVITIES';

export const SET_USER_INFO = 'SET_USER_INFO';

export const SET_DASHBOARD_BASIC_DATA = 'SET_DASHBOARD_BASIC_DATA';

export const GET_ACTIVITY_CATEGORIES = 'GET_ACTIVITY_CATEGORIES';
export const MANUALLY_SEND_EMAIL = 'MANUALLY_SEND_EMAIL'; // legacy boolean (kept for backward compatibility)
export const MANUALLY_SEND_EMAIL_INCREMENT = 'MANUALLY_SEND_EMAIL_INCREMENT'; // new: increment count

export const RELOAD_ACTIVITIES = 'RELOAD_ACTIVITIES';
export const PEND_FEEDBACK_COUNT = 'PEND_FEEDBACK_COUNT';
